import { storage } from "@/utils/storage"; //removeStorage
import fetch from "@/utils/request";
const pub = {
  state: {
    hotSearch: storage({ key: "public_hot_search" }) || [], // 热搜
  },
  mutations: {
    SET_HOT_SEARCH: (state, hotSearch) => {
      state.hotSearch = hotSearch;
      storage({ key: "public_hot_search", value: hotSearch });
    },
  },
  actions: {
    /* 热搜 */
    async fetchHotSearch({ commit }) {
      /* eslint-disable-next-line no-async-promise-executor */
      return new Promise(async (resolve, reject) => {
        try {
          const resp = await fetch({
            url: "/Index/getHotSearchList",
            method: "GET",
            unShowErrorTip: true,
          });
          const { state, data = [] } = resp;
          state === 0 && commit("SET_HOT_SEARCH", data || []);
          resolve({ flag: state === 0, ...resp });
        } catch (_) {
          reject(_);
        }
      });
    },
  },
};

export default pub;
